const nowMs = () => Date.now();

export const payloadEventId = (payload = {}) =>
  String(payload?.event_id || payload?.notification_id || '').trim();

const eventKey = (payload = {}) => {
  const eventId = String(payload?.event_id || '').trim();
  if (eventId) return `e:${eventId}`;
  const notificationId = String(payload?.notification_id || '').trim();
  if (notificationId) return `n:${notificationId}`;
  return '';
};

export const createSocketDeduper = (windowMs = 800) => {
  const seen = new Map();
  const seenIds = new Map();

  const cleanup = () => {
    const cutoff = nowMs() - Math.max(windowMs, 8000) * 2;
    for (const [key, ts] of seen.entries()) {
      if (ts < cutoff) seen.delete(key);
    }
    for (const [key, ts] of seenIds.entries()) {
      if (ts < cutoff) seenIds.delete(key);
    }
  };

  return (eventName, payload = {}, customKey = '') => {
    const idKey = eventKey(payload);
    if (idKey) {
      if (seenIds.has(idKey)) return false;
      seenIds.set(idKey, nowMs());
      if (seenIds.size > 400) cleanup();
      return true;
    }

    const comandaId = Number(payload?.comanda_id || payload?.id_comanda || payload?.id || 0);
    const detalleId = Number(payload?.detalle_id || 0);
    const mesaId = Number(payload?.id_mesa || payload?.mesa_id || 0);
    const key = customKey || `e:${eventName}:c:${comandaId}:d:${detalleId}:m:${mesaId}`;

    const ts = seen.get(key);
    const now = nowMs();
    if (ts && now - ts < windowMs) {
      return false;
    }

    seen.set(key, now);
    if (seen.size > 250) cleanup();
    return true;
  };
};
